import { makeStyles } from '@material-ui/core/styles';
import { variables } from '../../../styles';

const useStyles = makeStyles(() => ({
  formLabel: {
    color: variables.black50,
    display: 'block',
    fontWeight: 400,
    fontSize: 12,
    textAlign: 'start',
    marginBottom: 8,
    marginTop: 8,
  },
  formRequired: {
    color: variables.black50,
    marginLeft: 2,
  },
  icon: {
    color: variables.grey,
  },
}));

export default useStyles;
